import { FilterFieldType } from '@comfama/comfama-ui-react';

import { searchConfig } from '../config/searchConfig';

export interface FilterOption {
  label: string;
  value: string;
  icon: string;
}

export interface MainFilter {
  name: string;
  options: FilterOption[];
  type: FilterFieldType;
}

export interface HotWord {
  label: string;
  value: string;
  icon: string;
}

export interface ContentItem {
  category: string;
  title: string;
  description: string;
  image: string;
  url: string;
}

export interface TopContentSource {
  origin: string;
  mainFilter: MainFilter;
  hot_words: HotWord[];
  most_wanted: ContentItem[];
  content_for_you: ContentItem[];
}

interface TopContentResponse {
  _index: string;
  _id: string;
  _version: number;
  _seq_no: number;
  _primary_term: number;
  found: boolean;
  _source: TopContentSource;
}

export const getTopContent = async (): Promise<TopContentSource | null> => {
  const { baseUrl } = searchConfig.elastic;
  const { docPath, apiKey } = searchConfig.topContent;

  try {
    const response = await fetch(`${baseUrl}/${docPath}`, {
      method: 'GET',
      headers: {
        Authorization: apiKey,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: TopContentResponse = await response.json();

    if (!data.found || !data._source) {
      return null;
    }

    return data._source;
  } catch (error) {
    console.error('Error fetching top content:', error);
    return null;
  }
};
